import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {connect} from 'react-redux';
import {getMailingAdress} from './Constant';

function UpdateMailingFailed({selectedBan, bansInfo, messageContent}) {

  var failedBans = bansInfo.filter((item) => messageContent.failedBans.includes(item.ban));
  var succeededBans = bansInfo.filter(
    (item) => !messageContent.failedBans.includes(item.ban) && selectedBan.includes(item.ban)
  );

  const BanDescription = ({ban}) => {
    return (
      <div className='description'>
        <span className='product'>חשבון {ban.productDescription.description}</span>
        <span className='mailingAdress'>החשבונית נשלחת ל: {getMailingAdress(ban)}</span>
      </div>
    );
  };

  return (
    <div className='update-failed'>
      {succeededBans && (
        <div className='ban-group'>
          <span className='status'>כתובות שעודכנו בהצלחה</span>
          {succeededBans.map((item) => {
            return (
              <div className='ban-item' key={item.ban} >
                <Image src={require('./icons/check.svg')} />
                <BanDescription ban={item} />
              </div>
            );
          })}
        </div>
      )}

      {failedBans && (
        <div className='ban-group'>
          <span className='status'>כתובות שלא עודכנו</span>
          {failedBans.map((item) => {
            return (
              <div className='ban-item' key={item.ban} >
                <Image src={require('./icons/alert.svg')} />
                <BanDescription  ban={item} />
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  messageContent: state.updateMailingMethod.messageContent,
  bansInfo: state.updateMailingMethod.bansInfo,
  selectedBan: state.updateMailingMethod.selectedBan,
});

const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(UpdateMailingFailed);
